import { IClassname } from '@/lib/shared/model/classname';

export const Bathtub = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.85986 6.41549C3.85986 6.83504 3.9425 7.25048 4.10305 7.63809C4.26361 8.0257 4.49893 8.37789 4.7956 8.67455C5.09226 8.97122 5.44445 9.20654 5.83206 9.3671C6.21967 9.52765 6.63511 9.61029 7.05465 9.61029C7.4742 9.61029 7.88964 9.52765 8.27725 9.3671C8.66486 9.20654 9.01705 8.97122 9.31371 8.67455C9.61038 8.37789 9.8457 8.0257 10.0063 7.63809C10.1668 7.25048 10.2494 6.83504 10.2494 6.41549C10.2494 5.56818 9.91285 4.75558 9.31371 4.15644C8.71457 3.5573 7.90197 3.2207 7.05465 3.2207C6.20734 3.2207 5.39474 3.5573 4.7956 4.15644C4.19646 4.75558 3.85986 5.56818 3.85986 6.41549Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4727 17.2784H30.0303C30.1172 17.2772 30.2035 17.2939 30.2838 17.3273C30.3641 17.3607 30.4368 17.4101 30.4973 17.4726C30.5579 17.535 30.605 17.6092 30.6359 17.6905C30.6668 17.7718 30.6807 17.8586 30.6769 17.9454C30.5067 20.8754 29.2228 23.6294 27.0882 25.6436C24.9535 27.6577 22.1297 28.7797 19.1948 28.7796H12.8052C9.87034 28.7797 7.04647 27.6577 4.91185 25.6436C2.77722 23.6294 1.49335 20.8754 1.32313 17.9454C1.3193 17.8586 1.33324 17.7718 1.36412 17.6905C1.39499 17.6092 1.44214 17.535 1.50268 17.4726C1.56322 17.4101 1.63587 17.3607 1.71618 17.3273C1.7965 17.2939 1.88279 17.2772 1.96976 17.2784H8.3325"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1377 17.2775V14.0828C5.13772 13.7358 5.2319 13.3954 5.4102 13.0978C5.58849 12.8002 5.84422 12.5565 6.1501 12.3928C6.45599 12.2291 6.80057 12.1515 7.1471 12.1683C7.49363 12.185 7.82912 12.2955 8.1178 12.4879L11.6666 14.8495C11.9902 15.0627 12.3706 15.1735 12.7581 15.1673C13.1456 15.1612 13.5223 15.0384 13.839 14.815L15.2626 13.7927C15.6765 13.4971 16.1907 13.3781 16.6923 13.4617C17.1939 13.5454 17.6418 13.8248 17.9373 14.2387C18.2329 14.6525 18.3519 15.1668 18.2683 15.6684C18.1846 16.17 17.9051 16.6178 17.4913 16.9133L16.0664 17.9357C15.115 18.6089 13.9824 18.9792 12.8169 18.9979C11.6515 19.0165 10.5076 18.6829 9.53501 18.0405L8.33249 17.2775"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
